<template>
    <div>
        <h1 class="onboarding-title">Setup Your Approval Checklist</h1>
        <p class="onboarding-desc">You can require your approvers to acknowledge the following requirements
            before they approve a proof. We've created some default requirements for you. Feel free to delete,
            change or add to them!</p>
        <div class="onboarding-card">
            <div class="onboarding-card-section">
                <ul class="checklist-items">
                    <li v-for="(item, index) in checklistItems.items" :key="index">
                        <input type="text" class="auth-field"
                            v-model="checklistItems.items[index].name">
                        <button @click="deleteChecklistProperty(index)" class="checklist-delete" type="button" aria-label="Delete checklist item">
                            <img src="/img/trash-red.svg" width="22" alt="Delete">
                        </button>
                    </li>
                </ul>
                <div class="checklist-add-row">
                    <button @click="addChecklistItem" class="auth-btn-ghost checklist-add-button" type="button">
                        Add Checklist Item
                    </button>
                </div>
            </div>
        </div>
        <div class="onboarding-actions">
            <button @click="saveChecklist" class="auth-btn-primary">I'm Ready to Go</button>
            <button @click="handlePrevStep" class="auth-btn-ghost">Previous</button>
        </div>
    </div>
</template>
<script>

import { ALERT_TYPE } from '../../utils/constants';

const { WARNING } = ALERT_TYPE;

export default {
    name: "Screen3",
    props: {
        currentStep: {
            type: Number,
            required: true
        },
        handleNextStep: {
            type: Function,
            required: true
        },
        handlePrevStep: {
            type: Function,
            required: true
        },
        checklistItems: {
            type: Object,
            required: true
        },
    },
    data() {
        return {
            accountWide: true,
            checkListId: null,
            isSubmitting: false
        };
    },
    methods: {
        addChecklistItem() {
            this.checklistItems.items.push({ name: "" });
        },
        deleteChecklistProperty(index) {
            this.checklistItems.items.splice(index, 1);
        },

        validateChecklist() {
            if (!this.checklistItems.items || this.checklistItems.items.length === 0) {
                this.$A.AlertUser("Please add at least one Checklist item.", WARNING);
                return false;
            }
            const invalidItem = this.checklistItems.items.find(item => !item.name || item.name.trim() === "");
            if (invalidItem) {
                this.$A.AlertUser("Warning : Approval Checklist Cannot be Empty. ", WARNING);
                return false;
            }
            return true;
        },

        async saveChecklist() {
            if (this.isSubmitting) return;
            if (!this.validateChecklist()) return;
            this.isSubmitting = true;
            try {
                const checklistData = {
                    id: this.checklistItems.id,
                    name: "Default Checklist",
                    accountWide: this.accountWide,
                    items: this.checklistItems.items,
                };
                const savedChecklist = await this.$A.ProofChecklistService.SaveProofChecklist(checklistData);
                if (savedChecklist.id > 0) {
                    this.checkListId = savedChecklist.id;
                    for (const item of this.checklistItems.items) {
                        await this.$A.ProofChecklistService.SaveProofChecklistProperty(
                            savedChecklist.id,
                            item.id || null,
                            {
                                checklistId: savedChecklist.id,
                                name: item.name
                            }
                        );
                    }
                    this.$emit('checklist-saved');
                } else {
                    this.$A.AlertUser("Failed to save Checklist", WARNING);
                }
            } catch (error) {
                this.$A.AlertUser("Error saving Checklist:", WARNING);
            } finally {
                this.isSubmitting = false;
            }
        },
    }
};
</script>
<style scoped>
.checklist-items {
    display: flex;
    flex-direction: column;
    gap: 10px;
    list-style: none;
    margin: 0;
    padding: 0;
}

.checklist-items li {
    display: flex;
    align-items: center;
    gap: 8px;
}

.checklist-items li .auth-field {
    flex: 1;
}

.checklist-delete {
    flex-shrink: 0;
    background: transparent;
    border: 0;
    padding: 6px;
    border-radius: 6px;
    cursor: pointer;
    transition: background-color 120ms ease;
}

.checklist-delete:hover {
    background: rgba(235, 70, 84, 0.08);
}

.checklist-add-row {
    display: flex;
    justify-content: flex-end;
    margin-top: 12px;
}

.checklist-add-button {
    font-size: 13px;
    padding: 7px 13px;
}
</style>
